import { render, staticRenderFns } from "./point-order-list-search.vue?vue&type=template&id=044d0999"
import script from "./point-order-list-search.vue?vue&type=script&lang=js"
export * from "./point-order-list-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports